import { useMemo } from "react";
import {
  addMonths,
  endOfMonth,
  format,
  isAfter,
  isBefore,
  isSameMonth,
  startOfMonth,
  subMonths
} from "../../../../date-fns/index.js";
import { useCalendarConfiguration } from "../CalendarRoot.js";
import { parseDate } from "../utils.js";
function useNavigatorProps() {
  const config = useCalendarConfiguration();
  const {
    monthsCount,
    referenceDate,
    setReferenceDate,
    minDate: rawMinDate,
    maxDate: rawMaxDate,
    monthLabelFormat,
    dateFnsOptions
  } = config;
  const minDate = rawMinDate ? parseDate(rawMinDate, dateFnsOptions) : void 0;
  const maxDate = rawMaxDate ? parseDate(rawMaxDate, dateFnsOptions) : void 0;
  return useMemo(
    () => computeNavigatorProps({
      referenceDate,
      setReferenceDate,
      monthsCount,
      minDate,
      maxDate,
      monthLabelFormat,
      dateFnsOptions
    }),
    [referenceDate, setReferenceDate, monthsCount, minDate, maxDate, monthLabelFormat, dateFnsOptions]
  );
}
function computeNavigatorProps(data) {
  const { referenceDate, setReferenceDate, monthsCount, minDate, maxDate, dateFnsOptions, monthLabelFormat } = data;
  const currentStart = startOfMonth(referenceDate);
  const currentEnd = endOfMonth(addMonths(referenceDate, monthsCount - 1));
  const labels = [
    format(currentStart, monthLabelFormat, dateFnsOptions),
    format(currentEnd, monthLabelFormat, dateFnsOptions)
  ];
  const onClickPrev = () => {
    setReferenceDate(subMonths(currentStart, 1));
  };
  const onClickNext = () => {
    setReferenceDate(addMonths(currentStart, 1));
  };
  const disablePrev = minDate && (isBefore(currentStart, minDate) || isSameMonth(currentStart, minDate));
  const disableNext = maxDate && (isAfter(currentEnd, maxDate) || isSameMonth(currentEnd, maxDate));
  return {
    labels: monthsCount === 1 ? [labels[0], void 0] : labels,
    disablePrev,
    disableNext,
    onClickPrev,
    onClickNext
  };
}
export {
  computeNavigatorProps,
  useNavigatorProps
};
//# sourceMappingURL=useNavigatorProps.js.map
